import React from 'react'
import PropTypes from 'prop-types'
import {IconWrap} from './icon.style'

// Icon mapping from font-awesome to react-icons
import {
    FaLongArrowAltRight,
    FaLongArrowAltUp,
    FaCheck,
    FaPhone,
    FaMapMarkerAlt,
    FaSearch,
    FaStar,
    FaClock,
    FaCommentAlt,
    FaAngleDown,
    FaAngleRight,
    FaTwitter,
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaFacebook,
    FaEllipsisH,
    FaCalendarAlt,
    FaTags,
    FaShareAlt,
    FaInfoCircle,
    FaLifeRing,
    FaPaperPlane,
    FaEnvelope
} from 'react-icons/fa'

// Map font-awesome class names to react-icons components
const iconMap = {
    'far fa-long-arrow-right': FaLongArrowAltRight,
    'fal fa-long-arrow-right': FaLongArrowAltRight,
    'fal fa-long-arrow-up': FaLongArrowAltUp,
    'fal fa-check': FaCheck,
    'fa fa-check': FaCheck,
    'fal fa-phone': FaPhone,
    'fa fa-phone': FaPhone,
    'fa fa-map-marker-alt': FaMapMarkerAlt,
    'fal fa-map-marker-alt': FaMapMarkerAlt,
    'fa fa-search': FaSearch,
    'fa fa-star': FaStar,
    'fa fa-clock': FaClock,
    'fa fa-comment-alt-lines': FaCommentAlt,
    'far fa-angle-down': FaAngleDown,
    'fa fa-angle-down': FaAngleDown,
    'far fa-angle-right': FaAngleRight,
    'fa fa-angle-right': FaAngleRight,
    'fab fa-twitter': FaTwitter,
    'fab fa-facebook-f': FaFacebookF,
    'fab fa-facebook': FaFacebook,
    'fab fa-instagram': FaInstagram,
    'fab fa-linkedin': FaLinkedinIn,
    'far fa-ellipsis-h-alt': FaEllipsisH,
    'far fa-calendar': FaCalendarAlt,
    'far fa-tags': FaTags,
    'far fa-share-alt': FaShareAlt,
    'far fa-info-circle': FaInfoCircle,
    'far fa-comment-alt-dots': FaCommentAlt,
    'fal fa-life-ring': FaLifeRing,
    'fal fa-paper-plane': FaPaperPlane,
    'fal fa-envelope': FaEnvelope,
}

const Icon = ({iconName, icon: IconComponent, ...restProps}) => {
    // If a React component is passed directly, use it
    if (IconComponent) {
        return <IconWrap as="span" {...restProps}><IconComponent /></IconWrap>
    }

    // Try to map the font-awesome class name to a react-icon
    const MappedIcon = iconMap[iconName]
    if (MappedIcon) {
        return <IconWrap as="span" {...restProps}><MappedIcon /></IconWrap>
    }

    // Fallback to className-based icon (for any remaining cases)
    return <IconWrap className={iconName} {...restProps}/>
}

Icon.propTypes = {
    iconName: PropTypes.string,
    icon: PropTypes.elementType,
    color: PropTypes.string,
    fontSize: PropTypes.string,
    fontweight: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    lineHeight: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
}

Icon.defaultProps = {
    lineHeight: 1
}

export default Icon
